import { nextTick, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { sourcingOEMList } from '@/apis/oem'
import { formatOemProduct } from './useOemProduct'
import { useRoute } from 'vue-router'

export const formatOemProductSku = (v: any, rate: number) => ({
  ...v,
  id: v.productSku,
  code: v.searchSourceOrderNo,
  name: v.productName,
  img: v.productImg,
  oemProp: `${t('颜色')}: ${v.color ?? ''} ${t('尺寸')}: ${v.size ?? ' '}`,
  price: v.biggestprice ?? 0,
  PriceJpy: (v.biggestprice ?? 0) * rate ? Math.floor((v.biggestprice ?? 0) * rate) : 0
})

export default (productCode: any, productList: any, rate: any, emits: any) => {
  const list: any = ref([])
  const loading: any = ref(false)
  const route = useRoute()
  const getList = () => {
    if (productCode.value) {
      const row = productList.value.find((e:any) => e.searchSourceOrderNo === productCode.value)
      list.value = row.searchSourceOrderSkuResp.map((e: any) => formatOemProductSku({ ...row, ...e }, rate.value))
      nextTick(() => {
        emits('update:skuList', list.value)
      })
      return
    }
    if (route.query?.searchSourceOrderNo) {
      loading.value = true
      emits('update:skuLoading', true)
      sourcingOEMList({ searchSourceOrderNo: route.query.searchSourceOrderNo } as any).then(res => {
        list.value = res.data.records[0].searchSourceOrderSkuResp.map((e: any) => formatOemProductSku({ ...res.data.records[0], ...e }, rate.value))
        nextTick(() => {
          emits('getData', formatOemProduct(res.data.records[0], rate.value))
          emits('getSkuData', route.query.searchSourceOrderNo)
          emits('update:skuList', list.value)
        })
      }).finally(() => {
        loading.value = false
        emits('update:skuLoading', false)
      })
    }
  }

  return [
    loading,
    list,
    getList
  ]
}
